const scrollAnimate = require('./scrollAnimate');

const collapsible = () => {
    $(document.body).on('click', '#productDetails .collapsible .header, #productDetails .tab-pane .card-header', (e) => {
        const thisTarget = $(e.currentTarget);
        setTimeout(() => {
            scrollAnimate(thisTarget, $('header').outerHeight());
        }, 500);
    });
};

module.exports = {
    collapsible,
};
